import React from "react";

export default function Header() {
  return (
    <div id="header" className="header">
      <div className="header__content">
        <div className="header__content__text">
          <h1>Hi, my name is Alexandra</h1>
          <h2>I'm a web designer & developer</h2>
        </div>
      </div>
      <div className="header__content__social">
        <span className="header__content__social--text">Follow Me</span>
        <div className="header__content__social__links">
          <a
            href="https://instagram.com/alexandraep"
            target="_blank"
            rel="noreferrer"
            className="header__content__social__links--icon"
          >
            <i className="ri-instagram-fill"></i>
          </a>
          <a
            href="https://github.com/frontalexandraep"
            target="_blank"
            rel="noreferrer"
            className="header__content__social__links--icon"
          >
            <i className="ri-github-fill"></i>
          </a>
          <a
            href="https://www.linkedin.com/in/alexandra-pettersen-4a1753191/"
            target="_blank"
            rel="noreferrer"
            className="header__content__social__links--icon"
          >
            <i className="ri-linkedin-box-fill"></i>{" "}
          </a>
        </div>
      </div>
    </div>
  );
}
